module.exports = __webpack_public_path__ + "static/media/button-check-hover.9f08ca7c.svg";